import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Button } from './ui/button';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Reusable "Delete" trigger with confirmation.
 *   endpoint — REST collection path (e.g. "buildings")
 *   id       — record id
 *   label    — friendly label for confirmation prompt
 *   onDeleted— callback after success
 *   testId   — full data-testid value
 */
export default function DeleteButton({ endpoint, id, label = 'this item', onDeleted, testId, className = 'text-red-500 hover:bg-red-50' }) {
  const [busy, setBusy] = useState(false);
  const click = async () => {
    if (!window.confirm(`Delete ${label}? This cannot be undone.`)) return;
    setBusy(true);
    try {
      await axios.delete(`${API}/${endpoint}/${id}`, { withCredentials: true });
      toast.success('Deleted');
      onDeleted?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Delete failed');
    }
    setBusy(false);
  };
  return (
    <Button data-testid={testId} type="button" size="sm" variant="ghost" className={className} disabled={busy} onClick={click}>
      <Trash2 className="w-4 h-4" />
    </Button>
  );
}
